/**
 * GroupsSidebarList - Scrollable list of groups
 *
 * Features:
 * - Scrollable container for groups
 * - Renders GroupSidebarItem for each group
 * - Handles group selection
 */

import React from 'react';
import { ScrollView, View, StyleSheet } from 'react-native';
import { GroupSidebarItem } from './GroupSidebarItem';
import type { Group } from '@/services/groups/groupService';

interface GroupsSidebarListProps {
  groups: Group[];
  selectedGroupId: string | null;
  isExpanded: boolean;
  onGroupPress: (groupId: string) => void;
}

export const GroupsSidebarList: React.FC<GroupsSidebarListProps> = ({
  groups,
  selectedGroupId,
  isExpanded,
  onGroupPress,
}) => {
  if (groups.length === 0) {
    return null;
  }

  return (
    <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
      {groups.map(group => (
        <GroupSidebarItem
          key={group.id}
          group={group}
          isActive={selectedGroupId === group.id}
          isExpanded={isExpanded}
          onPress={() => onGroupPress(group.id)}
        />
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
